module.exports = __webpack_public_path__ + "img/slide-5.a22216da.png";